import { render, staticRenderFns } from "./SelfCompanyTokenSettingsComponent.vue?vue&type=template&id=3d1a71ca&scoped=true&"
import script from "./SelfCompanyTokenSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SelfCompanyTokenSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelfCompanyTokenSettingsComponent.vue?vue&type=style&index=0&id=3d1a71ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a71ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAlert,VBtn,VProgressLinear,VSimpleTable,VSubheader})
